import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  accessToken: null,
  gaClientId: null
};

export default function auth (state = initialState, action) {
  switch (action.type) {
  case types.RECEIVE_ACCESS_TOKEN: {
    const { accessToken } = action;

    return {
      ...state,
      accessToken
    };
  }

  case types.RECEIVE_GA_CLIENT_ID: {
    const { gaClientId } = action;

    return _.merge({}, state, {
      gaClientId
    });
  }

  case types.RESET_ENV:
    return _.merge({}, state, initialState);

  default:
    return state;
  }
}
